export const Asterisk = (
  <span aria-hidden='true' className='MuiFormLabel-asterisk' style={{ color: 'red' }}>
    {' '}
    *
  </span>
)
